import { render } from "./PersonnaliteComportement.vue?vue&type=template&id=f0048dfc&scoped=true"
import script from "./PersonnaliteComportement.vue?vue&type=script&lang=js"
export * from "./PersonnaliteComportement.vue?vue&type=script&lang=js"

import "./PersonnaliteComportement.vue?vue&type=style&index=0&id=f0048dfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0048dfc"]])

export default __exports__